/**
 * @generated SignedSource<<207fd4237915832db3f90db2e75c2254>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type processDefinitionsQueryDeployMutation$variables = {
  id: string;
};
export type processDefinitionsQueryDeployMutation$data = {
  readonly deployProcessDefinition: boolean | null | undefined;
};
export type processDefinitionsQueryDeployMutation = {
  response: processDefinitionsQueryDeployMutation$data;
  variables: processDefinitionsQueryDeployMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "kind": "ScalarField",
    "name": "deployProcessDefinition",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "processDefinitionsQueryDeployMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "processDefinitionsQueryDeployMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "0f983ecc0e046fed62877fd9eb10c317",
    "id": null,
    "metadata": {},
    "name": "processDefinitionsQueryDeployMutation",
    "operationKind": "mutation",
    "text": "mutation processDefinitionsQueryDeployMutation(\n  $id: ID!\n) {\n  deployProcessDefinition(id: $id)\n}\n"
  }
};
})();

(node as any).hash = "94b45bdd0ca6c3037f3e85b991bfbe53";

export default node;
